import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { StyleSheetManager } from 'styled-components';
import { UIContextProvider } from './context/ui.context';
import { AuthProvider } from './context/user.context';
import { PermissionProvider } from './context/permission.context';
import {InstanceContextProvider} from './context/instanceContext'
import { CookiesProvider } from 'react-cookie';

import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { initializeKeycloak } from './keycloak';

const blockedStyleProps = new Set([
  'active',
  'activeResults',
  'activeVideo',
  'back',
  'closing',
  'copy',
  'customStyles',
  'hasDisplayTask',
  'hover',
  'isDark',
  'isFill',
  'isIcon',
  'isMenu',
  'isProps',
  'isRegion',
  'isSelectedValue',
  'isSmall',
  'isSoon',
  'multi',
  'noIframe',
  'noMargin',
  'used',
])

const shouldForwardProp = (propName: string) => !blockedStyleProps.has(propName)
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Finish the code exchange and URL cleanup before mounting BrowserRouter.
void initializeKeycloak().then(authenticated => {
  if (!authenticated) {
    throw new Error('Keycloak authentication failed')
  }

  root.render(
    <>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <UIContextProvider>
            <CookiesProvider>
              <AuthProvider>
                <PermissionProvider>
                  <InstanceContextProvider>
                    <QueryParamProvider adapter={ReactRouter6Adapter}>
                      <App />
                    </QueryParamProvider>
                  </InstanceContextProvider>
                </PermissionProvider>
              </AuthProvider>
            </CookiesProvider>
          </UIContextProvider>
        </BrowserRouter>
      </StyleSheetManager>
    </>
  );
}).catch(() => {
  console.error('Keycloak initialization failed')
  root.render(
    <div role="alert">
      <p>Unable to sign in. Please try again.</p>
      <button onClick={() => window.location.reload()}>Try again</button>
    </div>
  )
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
